import React, { Component, useState, useEffect, memo, useRef } from 'react';

import {
  url
} from "../../API/Api"
import requests from "../../services/requests"
import services from '../../services/index';
import GLOBAL from "../../global"

import { io } from "socket.io-client";

import { useSelector, useDispatch } from "react-redux";
import {
  setItens
} from "../../store/actions"

import { withRouter } from "react-router-dom";
import { isEmpty, isArray, cloneDeep } from "lodash"
import { IoIosCheckmarkCircle } from "react-icons/io";

import {
  BoxPedido,
  BoxAccount
} from "./style"

import { v4 as uuidv4 } from 'uuid';

import styles from './style.module.css'



function InfoPedidosNaMesa(props) {
  const dispatch = useDispatch();

  const rdOrder = useSelector(state => state.order);
  const rdStores = useSelector(state => state.stores);

  const [mesa, setMesa] = useState(0)
  const [total, setTotal] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [additionalClass, setAdditionalClass] = useState('');
  const [showSendButton, setShowSendButton] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [statusTable, setStatusTable] = useState(0);
  const [isThereAnySended, setIsThereAnySended] = useState(false);

  useEffect(() => {
    setAdditionalClass(props.additionalClass)
  }, [props])


  useEffect(() => {
    const socket = io(url.localCasa, { transports: ["websocket"] });
    socket.on("updateitens", (mesa) => {
      updatItens(mesa, props.mesa)
    });

    socket.on('connect_error', () => {
      socket.connect();
    })
  }, [props.mesa])


  useEffect(() => {
    let response = services.totalizaItens(rdOrder.itens, 0, '', true);
    setTotal(response.data.total);
    setSubtotal(response.data.subtotal);
    const aux = cloneDeep(rdOrder.itens);
    const notSendeds = aux.filter(i => i.enviado === false);
    setShowSendButton(notSendeds.length > 0)

    if (rdOrder.itens.length > 0) {
      setStatusTable(rdOrder.itens[0].finalizado)
      const isThere = rdOrder.itens.findIndex(i => i.enviado === true);
      setIsThereAnySended(isThere !== -1)
    }
  }, [rdOrder])




  const callWaiter = async () => {
    const body = {
      tableNumber: props.mesa,
      storeID: rdStores.stores[0].id_loja,
      status: 1
    };
    try {
      setLoadingButton(true);
      const response = await requests.callWaiter(body);
      setLoadingButton(false);
      if (response) {
        props.funcAlert("Garçom solicitado");
      }
    } catch (error) {
      setLoadingButton(false);
      props.funcAlert(error, true);
    }
  }


  const callAccount = async () => {
    const body = {
      tableNumber: props.mesa,
      storeID: rdStores.stores[0].id_loja,
      status: 2
    };
    try {
      setLoadingButton(true);
      const response = await requests.setStatusTable(body);
      setLoadingButton(false);
      if (response) {
        setStatusTable(2);
        props.funcAlert("Conta solicitada");
      }
    } catch (error) {
      setLoadingButton(false);
      props.funcAlert(error, true);
    }
  }




  const updatItens = async (mesaFrom, auxMesa) => {
    try {

      if (Number(mesaFrom) !== Number(auxMesa)) return;
      const bodyRequest = {
        tableNumber: mesaFrom,
        storeID: props.loja.id_loja
      }

      let itens = await services.getItensMesaFromApi(bodyRequest);
      dispatch(setItens(itens));

    } catch (error) {
      alert("Ops... Algo deu errado")
    }
  }




  const editItem = (item, index) => {
    if (props.openItem && !item.enviado) {
      props.openItem(item, index);
    }
  }






  const orderItens = async () => {
    try {
      setLoadingButton(true);
      try {
        const allItens = rdOrder.itens;
        const notSendeds = rdOrder.itens.filter(i => !i.enviado);

        let initItens = notSendeds;



        let loja = rdStores.stores[0];
        let _subtotal = subtotal;
        let _total = total;
        let taxa = 0
        let pedido = {}



        pedido['loja'] = loja.id_loja;
        pedido['loja_desc'] = loja.descricao;



        let itens = [];

        initItens.forEach(element => {

          let subitens = [];
          let extras = [];
          let auxProdGratis = {};
          let objMassa, objBorda = {};


          const { borda, massa, produtos, toppings, prodGratis, partesCombo } = element.partes;

          if (element.is_pizza === 'S' && element.qt_particiona > 1 || element.is_combo === 'S') {
            if (element.is_pizza === 'S') {
              let qtParts = produtos.length;

              let valMaior = element.valMaiorPizza;
              let qtReal = (1 / qtParts) * element.quantidade;
              if (produtos.length > 0) {
                produtos.forEach(prod => {

                  let item = {
                    "id_produto": prod.ID_PRODUTO,
                    "nome_produto": prod.produto,
                    "codPdv": prod.CODIGO,
                    "obs": '',
                    "preco": parseFloat(valMaior),
                    "quantidade": qtReal,
                    "id_item": uuidv4()
                  }

                  subitens.push(item);
                })
              }
            } else {
              if (partesCombo.length > 0) {
                partesCombo.forEach(prod => {

                  let item = {
                    "id_produto": prod.id_produto,
                    "nome_produto": prod.produto,
                    "codPdv": prod.CODIGO,
                    "obs": '',
                    "preco": parseFloat(prod.PRECO.toFixed(2)),
                    "quantidade": 1,
                    "id_item": uuidv4()
                  }

                  subitens.push(item);
                })
              }
            }

          } else {
            if (produtos.length > 0) {
              produtos.forEach(prod => {
                let item = {
                  "id_produto": prod.ID_PRODUTO,
                  "nome_produto": prod.produto,
                  "codPdv": prod.CODIGO,
                  "obs": '',
                  "preco": parseFloat(prod.PRECO.toFixed(2)),
                  "id_item": uuidv4()
                }

                subitens.push(item);
              })
            }
          }



          if (toppings.length > 0) {
            toppings.forEach(top => {
              let item = {
                "id_produto": top.id_produto,
                "nome_produto": top.produto,
                "codePdv": top.codigo,
                "obs": '',
                "preco": parseFloat(top.PRECO.toFixed(2)),
                "id_item": uuidv4()
              }

              extras.push(item);
            })
          }

          if (massa) {
            objMassa = {
              "id_massa": massa.id_massa,
              "massa": massa.descricao,
              "codePdv": massa.CodPdv,
              "preco": massa.preco,
              "id_item": uuidv4()
            }
          }

          if (prodGratis) {
            auxProdGratis = {
              "id_produto": prodGratis.id_produto,
              "nome_produto": prodGratis.produto,
              "codePdv": prodGratis.codigo,
              "obs": '',
              "preco": 0,
              "quantidade": 1,
              "id_item": uuidv4()
            }
          }

          if (borda) {
            objBorda = {
              "id_borda": borda.id_borda,
              "borda": borda.descricao,
              "codePdv": borda.CodPdv,
              "preco": borda.preco,
              "id_item": uuidv4()
            }
          }


          let item = {
            "id_produto": element.id_produto,
            "nome_produto": element.produto,
            "codePdv": element.codigo,
            "preco": element.is_pizza === 'S' && element.qt_particiona > 1 || element.is_combo === 'S' ? 0 : parseFloat(element.PRECO.toFixed(2)),
            "subtotal": element.subtotal,
            "total": element.total,
            "combo": element.is_combo,
            "pizza": element.is_pizza,
            "quantidade": element.quantidade,
            "subitens": subitens,// depois
            "extras": extras, // depois
            "obs": element.obs ? element.obs : '',
            "promocao": false,
            "massa": objMassa,
            "borda": objBorda,
            "prodGratis": auxProdGratis,
            "id_item": uuidv4()
          }

          itens.push(item);
        });

        pedido['itens'] = itens;

        pedido['subtotal'] = parseFloat(_subtotal.toFixed(2));
        pedido['taxa'] = parseFloat(taxa.toFixed(2));
        pedido['total_pedido'] = parseFloat(_total.toFixed(2));


        pedido['currentJsonItens'] = allItens;


        pedido['tableNumber'] = Number(props.mesa);

        const response = await services.enviaPedidoEstouNaMesa(pedido, '123');


        if (response) {
          setSended();
        }

      } catch (e) {
        alert("Ops... Algo deu errado");
      }
    } finally {
      setLoadingButton(false);
    }
  }




  const setSended = () => {
    const itens = rdOrder.itens;

    const _itens = itens.map(i => {
      return {
        ...i,
        enviado: true
      }
    });

    dispatch(setItens(_itens));
    services.setTempPedido(JSON.stringify(_itens));
  }






  return (
    <>
      <BoxPedido className={`semBordas ${additionalClass}`}>

        <div className="title-pedido">
          <p id="titleCarrinho">Consumo mesa <strong>{props.mesa}</strong></p>
        </div>

        <div className={styles['content-itens--estou_na_mesa']}>
          {statusTable === 2 && <BoxAccount>
            <p style={{ fontSize: "1.908em" }}>Conta solicitada</p>
          </BoxAccount>}
          {
            rdOrder.itens.map((item, index) => {

              return (
                <div key={index}>
                  <div className={`${styles['content-item__']} ${styles.iteminbox}`} onClick={editItem.bind(this, item, index)}>
                    <div>
                      <p className="descItemPedido">{<IoIosCheckmarkCircle size={12} color={item.enviado ? "72bda3" : "#999"} />} {`${item.quantidade} x ${item.produto}`}</p>
                    </div>
                    <div>
                      <p id="priceItem">R$ {item.total.toFixed(2)}</p>
                    </div>
                  </div>



                  {
                    item.partes.massa ? (
                      item.partes.massa.descricao ? (
                        <div className="iteminbox">

                          <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Massa -></strong> {`${item.partes.massa.descricao} `}</p>


                        </div>
                      ) : ''
                    ) : ''
                  }




                  {
                    item.partes.borda ? (
                      item.partes.borda.descricao ? (
                        <div className="iteminbox">

                          <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Borda -></strong> {`${item.partes.borda.descricao} `}  {item.partes.borda.preco ? `( R$ ${item.partes.borda.preco.toFixed(2)} )` : ""}</p>


                        </div>
                      ) : ''

                    ) : ''
                  }





                  {
                    item.partes ? (
                      item.partes.produtos.map((parte, index) => {
                        return (
                          <div className="iteminbox" key={index}>

                            <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${parte.produto} `}</p>


                          </div>
                        )
                      })

                    ) : ''
                  }

                  {
                    item.partes ? (
                      item.partes.toppings.map((topping, index) => {
                        return (
                          <div className="iteminbox" key={index}>

                            <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`++${topping.produto} `}  {topping.PRECO ? `( R$ ${topping.PRECO.toFixed(2)} )` : ""}</p>


                          </div>
                        )
                      })

                    ) : ''
                  }

                  {
                    item.partes.partesCombo ? (
                      item.partes.partesCombo.map((produto, index) => {
                        return (
                          <div className="iteminbox" key={index}>

                            <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${produto.produto} `}</p>


                          </div>
                        )
                      })

                    ) : ''
                  }

                  {
                    item.partes.prodGratis ? (
                      item.partes.prodGratis.produto ? (
                        <div className="iteminbox">

                          <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;<strong>Promo -></strong> {`${item.partes.prodGratis.produto} `}</p>


                        </div>
                      ) : ''

                    ) : ''
                  }





                  {
                    item.obs ? (
                      <div className="iteminbox">

                        <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`--${item.obs} `}</p>

                      </div>
                    ) : ''
                  }
                </div>



              );
            })
          }
        </div>

        <div className={styles['footer-pedido']}>
          <div className="lineTotais">
            <span className="desc-title left">
              Sub Total da Mesa
            </span>
            <span className="desc-value right">
              R$ {subtotal.toFixed(2)}
            </span>
          </div>



          <div className="lineTotais">
            <span className="desc-title left">
              Total da Mesa
            </span>
            <span className="desc-value right" style={{ fontWeight: 'bold' }}>
              R$ {(total.toFixed(2))}
            </span>
          </div>
          {
            showSendButton ? (<button
              onClick={orderItens}
              disabled={loadingButton}
              type="button"
              className={`btn btn-primary btn-lg btn-block ${styles['btn-pagar']}`}
              style={{ background: "#2a9d8f" }}
            >
              {loadingButton ? "Aguarde..." : "Enviar itens"}
            </button>) : ''

          }


          <button
            onClick={callWaiter}
            type="button"
            className={`btn btn-primary btn-lg btn-block ${styles['btn-pagar']}`}
            style={{ background: "#e36414" }}
            disabled={loadingButton}
          >
            {loadingButton ? "Aguarde..." : "Chamar o garçom"}

          </button>


          {statusTable !== 2 && isThereAnySended && <button
            onClick={callAccount}
            type="button"
            className={`btn btn-primary btn-lg btn-block ${styles['btn-pagar']}`}
            style={{ background: "#264653" }}
            disabled={loadingButton}
          >
            {loadingButton ? "Aguarde..." : "Pedir a conta"}

          </button>}


        </div>
      </BoxPedido>
    </>
  );
}



export default withRouter(memo(InfoPedidosNaMesa))



